<template>
  <CRow>
    <CCol col="12" md="7">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/staff.svg" style="width:20px" /> Staff
          </p>
        </CCardHeader>
      <CCardBody>
       <CDataTable
          :items="staffItem"
          :fields="fields"
          table-filter
          items-per-page-select
          :items-per-page="5"
          sorter
          pagination
          clickable-rows
          hover
          @row-clicked="rowClicked"
          caption="Breed"
        />
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/staff.svg" style="width:20px" /> Staff Details
          </p>
        </CCardHeader>
            <CCardBody>
           <CForm>
                  
             <CInput
               
                label="Staff Code"
                horizontal
                autocomplete="name"
                name="staffCode"
                id="staffCode"
                required
                v-model="staffCode"
              />
                
                  
             <CInput
               
                label="Staff Name"
                horizontal
                autocomplete="name"
                  name="staffName"
                id="staffName"
                required
                v-model="staffName"
              />
                 <CInput
               
                label="Email"
                horizontal
                autocomplete="name"
                 name="staffName"
                id="staffName"
                required
                v-model="email"
              />
                
                  
             <CInput
               
                label="status"
                horizontal
                autocomplete="name"
                 name="status"
                id="status"
                required
                v-model="status"
              />
                <CInput
               
                label="Mobile No"
                horizontal
                autocomplete="name"
                name="mobileNumber"
                id="mobileNumber"
                required
                v-model="mobileNumber"
              />
                  
 <CRow>
              <CCol sm="3">
               <h5 style="font-size:15px">Status</h5>
              </CCol>
             <CCol sm="3" >
              <CSwitch class="mx-1" color="primary"  name="suspend"
                id="suspend"
                required checked variant="opposite" v-model="suspend" style="width:50px;float:left !important" shape="pill" v-bind="labelTxt" />
                  
              </CCol>
</CRow>
             </CForm>
            
          </CCardBody>
 <CCardFooter>
          <CButton color="info" style="width:100px" v-if="addButton" @click="addRoute">
            <CIcon name="cilPencil" />&nbsp;Add
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="saveButton" @click="updateRoute">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="danger" style="width:100px" v-if="deleteButton" @click="deleteRoute">
            <CIcon name="cilXCircle" />&nbsp;Delete
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addRoute">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="secondary" style="width:100px" v-if="cancelButton" @click="CancelRoute">
            <CIcon name="cilWarning" />&nbsp;Cancel
          </CButton>&nbsp;
          <CButton color="info" v-if="addnewButton" @click="addRouteplus">
            <CIcon name="cilPencil" />&nbsp;Add New
          </CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../tables/Table";
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
export default {
  components: { CTableWrapper },

  data() {
    return {
      staffItem:[],
      editstaff:[],
      staffCode:null,
      staffName:"",
      email:"",
      status:"",
      mobileNumber:"",
      suspend:"",
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      labelTxt: {
        labelOn: "yes",
        labelOff: "no"
      },
      fields: [
        {
          key: "staffCode",
          sortable: true
        },
        {
          key: "staffName",
          sortable: true
        },
        {
          key: "email",
          sortable: true
        },
        {
          key: "status",
          sortable: true
        },
        {
          key: "mobileNumber",
          sortable: true
        },
        {
          key: "suspend",
          sortable: true
        }
      ],
      items: [
        {
          isActive: true,
          Staff_Code: "10118",
          Staff_Name: "Dr.T.Manivannan",
          Email: "Manivannan@gmail.com",
          Role: "Doctor",
          Mobile_No: "9876765435",
          status: "Active"
        },
        {
          isActive: true,
          Staff_Code: "10123",
          Staff_Name: "Dr.M.Dhinaka",
          Email: "Dhinaka@gmail.com",
          Role: "Doctor",
          Mobile_No: "9879856754",
          status: "Active"
        }
      ]
    };
  },
  methods: {
     getStaffList() {
      APIService.staffList().then(res => {
        if (res.status == 200) {
          this.staffItem = res.data;

           this.staffCode =  this.staffItem[0].staffCode;
      this.staffName =  this.staffItem[0].staffName;
      this.email = this.staffItem[0].email;
      this.status = this.staffItem[0].status;
      this.mobileNumber =  this.staffItem[0].mobileNumber;
      this.suspend =  this.staffItem[0].suspend;
          // console.log("check",staffItem.suspend)
        }
      });
    },

    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editstaff = item;
      this.staffCode = item.staffCode;
      this.staffName = item.staffName;
      this.email = item.email;
      this.status = item.status;
      this.mobileNumber = item.mobileNumber;
      this.suspend = item.suspend;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addRoute() {
      let staffCode = this.staffCode;
      let staffName = this.staffName;
      let email = this.email;
      let status = this.status;
      let mobileNumber = this.mobileNumber;
      let suspend = this.suspend;
      let data = {
        staffCode,
        staffName,
        email,
        status,
        mobileNumber,
        suspend
      };
      APIService.saveStaff(data).then(res => {
        if (res.status == 200) {
          this.staffCode = null;
          this.staffName = "";
          this.email = "";
          this.status = "";
          this.mobileNumber = "";
          this.suspend = "";
          this.getStaffList();
           Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    addRouteplus() {
        this.staffCode = null;
          this.staffName = "";
          this.email = "";
          this.status = "";
          this.mobileNumber = "";
          this.suspend = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      (this.EditsaveButton = true)
      return getStaffList();
    },

    CancelRoute() {
         this.staffCode = null;
          this.staffName = "";
          this.email = "";
          this.status = "";
          this.mobileNumber = "";
          this.suspend = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      (this.EditsaveButton = false),  this.getStaffList();
    },
    updateRoute() {
       let id = this.editstaff._id;
       let staffCode = this.staffCode;
      let staffName = this.staffName;
      let email = this.email;
      let status = this.status;
      let mobileNumber = this.mobileNumber;
      let suspend = this.suspend;
      let value = {
       staffCode,
        staffName,
        email,
        status,
        mobileNumber,
        suspend
      };
      let data = { id, value };
      APIService.staffUpdate(data).then(res => {
        if (res.status == 200) {
       this.staffCode = null;
          this.staffName = "";
          this.email = "";
          this.status = "";
          this.mobileNumber = "";
          this.suspend = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
         this.getStaffList();
          Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    deleteRoute() {
      const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})

    },
    delete(){
      let id = this.editstaff._id;
      let data = { id };
      APIService.staffDelete(data).then(res => {
        if (res.status == 200) {
           this.staffCode = null;
          this.staffName = "";
          this.email = "";
          this.status = "";
          this.mobileNumber = "";
          this.suspend = "";
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false),  this.getStaffList();
        }
      });
    }
  },
  created() {
    this.getStaffList();
  }
};
</script>
